import { render, staticRenderFns } from "./OwnerWrite.vue?vue&type=template&id=594650c5&"
import script from "./OwnerWrite.vue?vue&type=script&lang=js&"
export * from "./OwnerWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports